import {
  takeEvery, select, put,
} from 'redux-saga/effects';
import { IFirstSpinner, IEntityConfig, ISpinnerRenderData } from 'src/typings/spinner';
import { requestSelectors } from 'src/store/requests/selectors';
import { ActionTypes, Actions } from 'src/store/spinner/actions';
import { getEntityOptions } from 'src/api';

const entityOptionsRequests = new Map<string, Promise<any>>();

const getEntityOptionsOnce = (entity: string, id: string): Promise<any> => {
  const requestKey = `${entity}:${id}`;
  const existingRequest = entityOptionsRequests.get(requestKey);
  if (existingRequest) return existingRequest;

  const request = getEntityOptions(entity, id);
  entityOptionsRequests.set(requestKey, request);
  request.catch(() => entityOptionsRequests.delete(requestKey));

  return request;
};

export function* setCompleteSpinnerSaga(action: {
  type: string,
  payload: IFirstSpinner,
}) {
  const spinnerData: {
    [key: string]: ISpinnerRenderData;
    firstSpinner: any;
} = yield select(requestSelectors.spinner.getSpinnerViewData);
  const currentSpinner = action.payload;
  const entityName = currentSpinner?.name;
  const entityId = currentSpinner?.['name-id'];
  const spinnerEntity = entityName && entityId
    ? spinnerData?.[entityName]?.[entityId]
    : undefined;
  const spinnerWindRose: {
    src: string | undefined,
    deg: number | string | undefined,
    disabled: boolean | undefined,
    bg_src: string | undefined,
  } = {
    src: '',
    deg: 0,
    disabled: true,
    bg_src: '',
  };

  if (!entityName || !entityId || (spinnerData && !spinnerEntity)) return;

  try {
    const fetchData: {
       data: IEntityConfig,
     } = yield getEntityOptionsOnce(entityName, entityId);

    if (entityName && entityId) {
      if (fetchData.data) {
        if (entityName === 'floor') {
          spinnerWindRose.src = fetchData.data.floor_compass_image;
          spinnerWindRose.deg = fetchData.data.floor_compass_angle;
          spinnerWindRose.disabled = fetchData.data.floor_compass_display;
          spinnerWindRose.bg_src = fetchData.data.floor_compass_bg_image;
        } else {
          spinnerWindRose.src = fetchData.data.spinner_compass_image;
          spinnerWindRose.deg = fetchData.data.spinner_compass_angle;
          spinnerWindRose.disabled = Boolean(fetchData.data.spinner_compass_display);
          spinnerWindRose.bg_src = fetchData.data.spinner_compass_bg_image;
        }
      }
      if (spinnerEntity?._windRose) {
        spinnerWindRose.src = spinnerEntity._windRose.src;
        spinnerWindRose.deg = spinnerEntity._windRose.degree;
        spinnerWindRose.disabled = spinnerEntity._windRose.disabled;
        spinnerWindRose.bg_src = spinnerEntity._windRose.bg_src || '';
      }

      yield put(Actions.setEntityConfig(fetchData.data));
      if (action.type === ActionTypes.SET_APP_CURRENT_SPINNER) {
        yield put(Actions.setAppWindRose(spinnerWindRose));
      } else {
        yield put(Actions.setWindRose(spinnerWindRose));
      }
    }
  } catch (e) {
    yield put(Actions.setEntityConfig(null));
  }
}

export function* spinnerWatchSaga() {
  yield takeEvery(ActionTypes.SET_CURRENT_SPINNER, setCompleteSpinnerSaga);
  yield takeEvery(ActionTypes.SET_APP_CURRENT_SPINNER, setCompleteSpinnerSaga);
}
